import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {FormattedMessage, injectIntl} from 'react-intl'
import ThumbnailBrowser from './ThumbnailBrowser'
import PhotoBrowser from './PhotoBrowser'

const loriOTooleUrl = 'http://www.loriotoole.com/'
const buyPrintsUrl = 'http://loriotoolephotography.zenfolio.com/p862783044'

class Album extends Component {
  render () {
    const {album, photo} = this.props.match.params

    return (
      <article>
        <Helmet>
          <title>{this.props.intl.formatMessage({id:`${album}AlbumPageTitle`})}</title>
          <body className="noscroll" />
        </Helmet>

        <hgroup>
          <h1>Rebecca & Eric</h1>
          <h2>
            <FormattedMessage id={`${album}AlbumTitle`} />
          </h2>
        </hgroup>

        {album === 'wedding' && (
          <p>
            <FormattedMessage id="photosIntroPara" values={{
              loriOTooleLink: <a href={loriOTooleUrl}>Lori O’Toole</a>,
              printServiceLink: <a href={buyPrintsUrl}><FormattedMessage id="printService" /></a>,
            }} />
          </p>
        )}

        <p>
          <FormattedMessage id="thumbnailUserInstructions" />
        </p>
        
        <ThumbnailBrowser album={album} />
        {photo ? <PhotoBrowser album={album} photo={photo} albumTitle="Wedding Photos" /> : null}
      </article>
    )
  }
}

export default injectIntl(Album)



// WEBPACK FOOTER //
// ./src/Album.js